import { Component, OnInit } from '@angular/core';
import { BookingService } from '../../../../core/services/booking.service';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MustMatch } from './../_helpers/must-match.validator';
import { RutValidator } from 'ng2-rut';
import { Location } from '@angular/common';
declare let gtag: (property: string, value: any, configs: any) => {};
@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {
  public option: string = '';
  public reference: string;
  public date: string;
  public plant: string;
  public hour: string;
  public address: string;
  public patente: string;
  public phone: string;
  public tarifa: string;
  public code: string;
  public regiones = [];
  public comunasSelect = [];
  registerForm: FormGroup;
  registerFormFactura: FormGroup;
  submitted = false;
  public selectText = [];

  constructor(
    private formBuilder: FormBuilder,
    private bookingService: BookingService,
    private route: Router,
    private rv: RutValidator,
    private location: Location
  ) { }

  ngOnInit() {
    this.buildBillForm();
    this.buildReceiptForm();
    this.getRegionAndCommune();
    this.getBookingData();
  }

  /* Creates the bill payment form */
  buildBillForm() {
    this.registerForm = this.formBuilder.group({
      name: ['', [Validators.required, Validators.minLength(5)]],
      email: ['', [Validators.required, Validators.email]],
      rut: ['', [Validators.required, this.rv]]
    });
  }

  /* Creates the receipt payment form */
  buildReceiptForm() {
    this.registerFormFactura = this.formBuilder.group({
      razon: ['', [Validators.required, Validators.minLength(3)]],
      rutEmpresa: ['', [Validators.required, this.rv]],
      address: ['', [Validators.required, Validators.minLength(5)]],
      region: ['', Validators.required],
      comuna: ['', Validators.required],
      giro: ['', [Validators.required, Validators.minLength(5)]],
      emailFactura: ['', [Validators.required, Validators.email]],
      emailConfirmFactura: ['', Validators.required]
    },
      {
        validator: [MustMatch('emailFactura', 'emailConfirmFactura')]
      });
  }

  /* Gets the available regions and communes */
  getRegionAndCommune() {
    this.bookingService.getRegionAndCommune().subscribe(
      response => {
        this.regiones = response.message;
      }
    );
  }

  /* Gets the booking data to display it to the user on screen */
  getBookingData() {
    this.bookingService.getBookingData().subscribe(
      (response) => {
        this.date = response.selected_date;
        if (this.date === undefined) {
          this.route.navigateByUrl('/');
        } else {
          this.reference = response.reference;
          this.date = this.convertStringToFomart(response.selected_date);
          this.plant = response.plant;
          this.hour = moment(response.selected_hour, ['H:mm']).format('h:mm A');
          this.address = response.address_plant;
          this.patente = response.vehicle_patent;
          this.phone = response.phone_number;
          this.tarifa = response.tarifa;
          this.code = response.reservation_code;
          this.registerForm.patchValue({
            name: response.contact_name,
            email: response.email
          });
        }
      }
    );
  }

  get f() { return this.registerForm.controls; }
  onSubmitBill() {
    const valor = this.tarifa.replace(/\./g, '');
    this.submitted = true;
    if (this.registerForm.invalid) {
      return;
    }
    if (this.registerForm.valid) {
      gtag('event', 'Reserva10', {'event_category': 'Reserva10', 'event_label': 'Reserva10', 'value': 'Reserva10'});
      // this.goWebpay();
      this.bookingService.paymentFinaly(
        this.option,
        valor,
        this.patente,
        this.phone,
        this.registerForm.value.email,
        this.registerForm.value.rut,
        this.registerForm.value.name, 0, 0, 0, 0).subscribe(
          response => {
            if (response.status) { this.goWebpay(); }
          }
        );
    }
  }

  onSubmitReceipt() {
    this.submitted = true;
    const valor = this.tarifa.replace(/\./g, '');
    if (this.registerFormFactura.invalid) {
      return;
    }
    if (this.registerFormFactura.valid) {
      gtag('event', 'Reserva10', {'event_category': 'Reserva10', 'event_label': 'Reserva10', 'value': 'Reserva10'});
      this.bookingService.paymentFinaly(
        this.option,
        valor,
        this.patente,
        this.phone,
        this.registerFormFactura.value.emailFactura,
        this.registerFormFactura.value.rutEmpresa,
        this.registerFormFactura.value.razon,
        this.registerFormFactura.value.address,
        this.registerFormFactura.value.region,
        this.registerFormFactura.value.giro,
        this.registerFormFactura.value.comuna,
      ).subscribe(
        response => {
          if (response.status) { this.goWebpay(); }
        }
      );
    }
  }

  goWebpay() {
    this.bookingService.paymentWebPay().subscribe(
      res => {
        window.location.href = res.url;
      }
    );
  }

  convertStringToFomart(dt, format = 'DD MMMM YYYY') {
    moment.locale('es-es');
    return moment.utc(dt).format(format);
  }

  navigatorBack() {
    gtag('event', 'Atras4', {'event_category': 'Atras4', 'event_label': 'Atras4', 'value': 'Atras4'});
    this.location.back();
  }

  onChangeRegion($event) {
    if (this.registerFormFactura.value.region !== '') {
      this.selectText = this.regiones.filter(
        array => array.region === this.registerFormFactura.value.region);
      this.comunasSelect = this.selectText[0].comunas;
      this.registerFormFactura.patchValue({
        comuna: ''
      });
    } else {
      this.comunasSelect = [];
    }
  }
  atras(){
    gtag('event', 'Cancelar2', {'event_category': 'Cancelar2', 'event_label': 'Cancelar2', 'value': 'Cancelar2'});
    this.route.navigate(['/booking/search-type']);
  }
}
